<div class="progressive-disclosure-group-select" data-test="progressive-disclosure-group-select">
  <!-- Collapsed state: clickable text -->
  <div
    *ngIf="!isExpanded"
    [attr.aria-expanded]="false"
    [attr.aria-label]="'Post to a group?' | translate"
    (click)="toggleExpanded()"
    (keydown.enter)="toggleExpanded()"
    (keydown.space)="toggleExpanded(); $event.preventDefault()"
    class="disclosure-toggle collapsed"
    role="button"
    tabindex="0"
  >
    <span class="toggle-text">{{ "Post to a group?" | translate }}</span>
    <fa-icon class="toggle-icon" icon="chevron-down"></fa-icon>
  </div>

  <!-- Expanded state: dropdown -->
  <div *ngIf="isExpanded" class="expanded-content">
    <!-- Group selector dropdown -->
    <div class="group-select-container" [@expandCollapse]>
      <ng-container *ngIf="viewModel$ | async as vm">
        <ng-container *ngIf="vm.hasGroups; else noGroups">
          <ng-select
            [clearable]="false"
            [dropdownPosition]="props.dropdownPosition || 'auto'"
            [items]="vm.options"
            [ngModel]="formControl.value"
            [placeholder]="'Select a group' | translate"
            [searchable]="true"
            (ngModelChange)="onGroupChange($event)"
            class="group-select-dropdown"
            bindLabel="label"
            bindValue="value"
          >
          </ng-select>
        </ng-container>
      </ng-container>

      <ng-template #noGroups>
        <div class="no-groups-message">
          <p>{{ "You have no groups yet." | translate }}</p>
          <a [href]="groupsPageUrl" class="groups-link" rel="noopener noreferrer" target="_blank">
            {{ "Join groups to post here" | translate }}
            <fa-icon class="ms-1" icon="external-link-alt"></fa-icon>
          </a>
        </div>
      </ng-template>
    </div>
  </div>
</div>
